module.exports = __webpack_public_path__ + "img/serveimg.8bcde576.png";